<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <div class="demo-form-inline">
          <el-form-item label="按起止时间:">
            <el-date-picker
              v-model="formInline.date"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="微信昵称">
            <el-input v-model="formInline.client_nick_name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="formInline.mobile"></el-input>
          </el-form-item>
        </div>

        <div class="bottom_center">
          <el-form-item style="min-width: 150px">
           
            <el-button
              type="primary"
              style="background: #1890ff"
              @click="getList"
              >查询</el-button
            >
            <el-button type="primary" class="vubutton" @click="onSubmit"
              >重置</el-button
            >
             <download-excel
              :fetch="fetchData"
              :fields="json_fields"
              :before-generate="startDownload"
              name="充值订单列表.xls"
              style="display: inline-block; margin-left: 10px"
            >
              <el-button
                type="primary"
                :loading="upload"
                style="
                  background: #1baeae;
                  color: #fff;
                  border: none;
                  height: 40px;
                "
                >导出</el-button
              >
            </download-excel>
          </el-form-item>
        </div>
      </el-form>
       <el-row :gutter="10">
          <el-col :span="3">
            <div class="top-title">总订单数</div>
            <div class="top-numnber">{{ total }}</div>
          </el-col>
          <el-col :span="3">
            <div class="top-title">合计金额</div>
            <div class="top-numnber">{{ totalamount / 100 }}</div>
          </el-col>
        </el-row>

      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="
          () => 'text-align: center;background:#eef1f6;width:100%'
        "
      >
        <template slot="empty">
          <noCart></noCart>
        </template>

        <el-table-column label="微信名称" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.nick_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.pay_type }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款时间" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.prepay_amount }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="page_size"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'employee',
  data() {
    return {
      formInline: {},
       json_fields: {
        ID: 'id',
        微信名称: 'nick_name',
           联系方式: 'mobile',
             支付方式: 'pay_type',
              创建时间: 'created_at',
               付款时间: 'updated_at',
        金额: 'prepay_amount', //如果命名的标题有空格,需要用双引号
      
       
      
          
      
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      tableData: [],
      dialogFormVisible: false,
      form: [],
      formLabelWidth: '200px',
      total: 0,
      totalamount:0,
      upload:false,
      page_size: 20,
      page_no: 1,
    };
  },
  methods: {
     startDownload() {
      this.upload = true;
      // alert('show loading');
      },
     async fetchData() {
      
    if(!this.formInline.date || !this.formInline.date[0] || !this.formInline.date[1]){
       this.$alert('请选择时间')
       this.upload = false;
      return;
    }
     let statedate=new Date(this.formInline.date[0]),enddate=new Date(this.formInline.date[1]);
     if((enddate.getTime() - statedate.getTime()) > 7776000000){
        this.$alert('仅支持导出3个月订单');
        this.upload = false;
       return
     }
      //  console.log( '更新：',this.formInline.date);
     
      const url = this.$userList.user_order_search_vip;
      const data = {
        client_nick_name: this.formInline.client_nick_name || '',
        mobile: this.formInline.mobile,
        // start_date: (this.formInline.date && this.formInline.date[0]) || '',
        // end_date: (this.formInline.date && this.formInline.date[1]) || '',
         page_index: 1,
        page_size: this.total,
      };
      if(this.formInline && this.formInline.date && this.formInline.date.length>0){
            data.start_date=fecha.format(
              new Date(this.formInline.date[0]),
              'yyyy-MM-dd HH:mm:ss'
            )
              data.end_date=fecha.format(
              new Date(this.formInline.date[1]),
              'yyyy-MM-dd HH:mm:ss'
            )
        }
       
     
      console.log(data);
      let tableData=[] || []
       let res= await this.$http.post(url, data);
        tableData = res.data.items || [];
        // tableData.forEach((item)=>{
        // item.total_price=item.total_price / 100;
        // })
        // this.tableData = res.data.items;
          // this.total = res.data.count;
          // this.tabPage = res.data;

        this.upload = false;


         this.tableData = res.data.items || [];
          if (this.tableData.length) {
            
            this.tableData = this.tableData.map((item) => {
              item.prepay_amount=item.prepay_amount / 100;
              item.created_at = fecha.format(
                new Date(item.created_at),
                'yyyy-MM-dd HH:mm:ss'
              );
              item.updated_at = fecha.format(
                new Date(item.updated_at),
                'yyyy-MM-dd HH:mm:ss'
              );
              return item;
            });
          }

          this.total = res.data.count;
          this.totalamount=res.data.total_amount || 0;

        return tableData;

    },
    pageSize(index) {
      this.page_no = index;
      this.getList();
    },
    noStatus() {
      this.dialogFormVisible = false;
    },
    onSubmit() {
      console.log('submit!');
      this.formInline = {};
      this.getList();
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },

    getList() {
      const url = this.$userList.user_order_search_vip;
      const data = {
        client_nick_name: this.formInline.client_nick_name || '',
        mobile: this.formInline.mobile,
        // start_date: (this.formInline.date && this.formInline.date[0]) || '',
        // end_date: (this.formInline.date && this.formInline.date[1]) || '',
        page_index: this.page_no,
        page_size: this.page_size,
      };
      if(this.formInline && this.formInline.date && this.formInline.date.length>0){
            data.start_date=fecha.format(
              new Date(this.formInline.date[0]),
              'yyyy-MM-dd HH:mm:ss'
            )
              data.end_date=fecha.format(
              new Date(this.formInline.date[1]),
              'yyyy-MM-dd HH:mm:ss'
            )
        }
      this.$http.post(url, data).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.items;
          if (this.tableData.length) {
            this.tableData = this.tableData.map((item) => {
               item.prepay_amount=item.prepay_amount / 100;
              item.created_at = fecha.format(
                new Date(item.created_at),
                'yyyy-MM-dd HH:mm:ss'
              );
              item.updated_at = fecha.format(
                new Date(item.updated_at),
                'yyyy-MM-dd HH:mm:ss'
              );
              return item;
            });
          }

          this.total = res.data.count;
             this.totalamount=res.data.total_amount || 0;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
  },
  created() {
    this.$root.setheadName();
    this.getList();
    // this.getMuList();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}

.top_div {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}

.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}

/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}

.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}

.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}

.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
}


.top-title {
  font-weight: 400;
  color: #606266;
  font-size: 14px;
}
.top-numnber {
  font-weight: 700;
  line-height: 40px;
  font-size: 23px;
}
</style>
